import Link from 'next/link';
import React, { useMemo, useState } from 'react';
import { ZipPage } from 'utils/types';
import { encodeZipPageHref } from 'utils/urls';

interface IProps {
  title: string;
  zipPages: ZipPage[];
  className?: string;
}

export const ZipCodesListSection: React.FC<IProps> = ({ title, zipPages, className }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredZipPages = useMemo(() => {
    if (!searchQuery.trim()) {
      return zipPages;
    }

    const query = searchQuery.toLowerCase();
    return zipPages.filter((zipPage) => zipPage.zipCode.toLowerCase().includes(query));
  }, [zipPages, searchQuery]);

  return (
    <div className={`mb-8 flex flex-col gap-6 text-eggplant md:mb-16 md:gap-8 ${className || ''}`}>
      <div className='flex w-full flex-row items-start justify-between gap-4'>
        <div className='flex flex-col items-start justify-start'>
          <div className='text-red-950 leading-trim-both text-edge-cap justify-start text-xl font-bold leading-[120%] sm:text-2xl md:text-3xl'>
            {title}
          </div>
        </div>
        <div className='flex w-64 flex-col items-end justify-end'>
          <div className='relative flex h-10 w-full flex-row rounded-lg border border-neutral-200 bg-white text-base text-neutral-800'>
            <div className='absolute left-3 top-0 flex h-full items-center'>
              <i className='fa-solid fa-magnifying-glass text-eggplant-500'></i>
            </div>
            <input
              placeholder='Search ZIP codes...'
              type='text'
              value={searchQuery}
              onChange={(event) => setSearchQuery(event.currentTarget.value)}
              className='size-full rounded-lg border-none bg-white pl-10 pr-4 text-eggplant-500 placeholder:font-medium placeholder:text-neutral-700 focus:border-none focus:outline-none'
            />
          </div>
        </div>
      </div>

      <div className='grid w-full grid-cols-1 gap-3 md:grid-cols-2 md:gap-4 lg:grid-cols-3'>
        {filteredZipPages.map((zipPage) => (
          <Link key={zipPage.id} href={encodeZipPageHref(zipPage, zipPage.zipCode)}>
            <div className='inline-flex w-full items-center justify-between rounded-lg bg-white p-4 shadow-[10px_8px_16px_0px_rgba(0,0,0,0.10)] outline outline-1 outline-offset-[-1px] outline-neutral-100 transition-shadow hover:shadow-[10px_8px_16px_0px_rgba(0,0,0,0.15)]'>
              <div className='text-red-950 justify-center text-sm font-medium leading-relaxed sm:text-base md:text-lg'>
                {zipPage.zipCode}
              </div>
              <i className='fa fa-chevron-right text-red-950 text-sm' />
            </div>
          </Link>
        ))}
      </div>

      {filteredZipPages.length === 0 && searchQuery && (
        <div className='py-8 text-center text-neutral-500'>No ZIP codes found matching "{searchQuery}"</div>
      )}
    </div>
  );
};
